import PrivateRoute from './PrivateRouteContainer';

export default PrivateRoute;
